const taskTypes = {
    'special': 'special',
    'leagues': 'leagues',
    'ref': 'ref'
}
export default taskTypes